module.exports = __webpack_public_path__ + "static/media/006-streaming.71eefd71.svg";